<template>
  <v-data-table :headers="headers" :items="localLocations" class="elevation-1" :items-per-page="-1" mobile-breakpoint="768" disable-sort>
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>保管場所マスタ</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-dialog v-model="dialogAdd" persistent>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on">保管場所の新規作成</v-btn>
          </template>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <span class="text-h5">保管場所の新規作成</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedLocation.name" label="保管場所" :rules="[rules.required]" autofocus></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeAdd">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localAddLocation">新規作成</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogEdit" persistent>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <span class="text-h5">変更</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedLocation.name" label="保管場所" :rules="[rules.required]" autofocus></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeEdit">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localEditLocation">変更</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
        <v-dialog v-model="dialogDelete" persistent>
          <v-form>
            <v-card>
              <v-card-title>
                <span class="text-h5">この保管場所を削除してよろしいですか？</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedLocation.name" label="保管場所" disabled></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete">キャンセル</v-btn>
                <v-btn color="blue darken-1" text @click="localDeleteLocation">削除</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </v-toolbar>
    </template>
    <template v-slot:[`item.action`]="{ item }">
      <v-icon @click="openEdit(item)"> mdi-pencil </v-icon>
    </template>
    <template v-slot:[`item.action2`]="{ item }">
      <v-icon @click="openDelete(item)"> mdi-delete </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      headers: [
        { text: "保管場所", value: "name" },
        { text: "変更", value: "action", align: "center" },
        { text: "削除", value: "action2", align: "center" },
      ],
      localLocations: [],
      editedLocation: { id: "", name: "" },
      defaultLocation: { id: "", name: "" },
      rules: {
        required: (value) => !!value || "入力必須です。",
      },
    };
  },
  created() {
    this.localLocations = this.$store.state.locations;
  },
  watch: {
    dialogAdd(val) {
      val || this.closeAdd();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  methods: {
    openEdit(location) {
      this.editedLocation = Object.assign({}, location);
      this.dialogEdit = true;
    },
    openDelete(location) {
      this.editedLocation = Object.assign({}, location);
      this.dialogDelete = true;
    },
    closeAdd() {
      this.$refs.form.resetValidation();
      this.dialogAdd = false;
      this.$nextTick(() => {
        this.editedLocation = Object.assign({}, this.defaultLocation);
      });
    },
    closeEdit() {
      this.$refs.form.resetValidation();
      this.dialogEdit = false;
      this.$nextTick(() => {
        this.editedLocation = Object.assign({}, this.defaultLocation);
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedLocation = Object.assign({}, this.defaultLocation);
      });
    },
    localAddLocation() {
      if (this.$refs.form.validate()) {
        this.addLocation(this.editedLocation);
        this.closeAdd();
      }
    },
    localEditLocation() {
      if (this.$refs.form.validate()) {
        this.updateLocation(this.editedLocation);
        this.closeEdit();
      }
    },
    localDeleteLocation() {
      this.deleteLocation(this.editedLocation.id);
      this.closeDelete();
    },
    ...mapActions(["addLocation", "updateLocation", "deleteLocation"]),
  },
};
</script>

<style></style>
